import React from 'react'

import styles from './Menu.module.css'

const Menu = () => {
  return (
        <div className={styles.wrapper}>
          {/* <p><a href='/'>home</a></p> */}
          <p><a href='/#/cv'>biography</a></p>
          <p><a href='/#/concerts'>calendar</a></p>
          <p><a href='/#/contact'>contact</a></p>
        </div>
      )
}

export default Menu